import { AnimalType, IRetryAdjustFeedTableItem, IValveUpdateError } from "shared/api/api";


export const GET_DATA = 'GET_DATA';
export const SET_COMMIT_STATUS = 'SET_COMMIT_STATUS';
export const SAVE_RETRY = 'SAVE_RETRY';
export const DELETE_RETRY = 'DELETE_RETRY';

export const SET_COMMIT_STATUS_ON_ALL = 'SET_COMMIT_STATUS_ON_ALL';
export const GET_VALVE_UPDATE_ERRORS = 'GET_VALVE_UPDATE_ERRORS';
export const UPDATE_DISTRIWIN_VALVE_ADJUSTMENTS = 'UPDATE_DISTRIWIN_VALVE_ADJUSTMENTS';
export interface RetryAdjustFeedState {
    retryAdjustFeedItems: RetryAdjustFeedItemApp[];
    valveUpdateErrors: IValveUpdateError[];
    attemptingToUpdateAll: boolean;
    commitAll: boolean;
    loading: boolean;
}

export interface RetryAdjustFeedItemApp extends IRetryAdjustFeedTableItem {
    ids: string[];
    buildingOrder: number | undefined;
    sectionOrder: number | undefined;
    penOrder: number | undefined;
    shouldBeCommited: boolean;
    showSpinner: boolean;
    status: boolean;
    animalType?: AnimalType;
}
